<template>
  <v-container fluid id="NewWorkOrder">
    <!-- submitted dialog -->
    <v-dialog v-model="submitted" persistent width="500">
      <v-card>
        <v-card-text v-if="submitting">
          <h2 class="title mb-4 pt-4">Submitting App Support Request...</h2>
          <v-progress-linear
            indeterminate
            class="mb-0 mt-4"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-else class="text-center">
          <h2 class="title mb-4 pt-4">
            App Support Request successfully submitted!
          </h2>
          <v-btn color="primary" outlined to="/app-support"
            ><v-icon left>chevron_left</v-icon> Back to My App Support
            Requests</v-btn
          >
          <div>
            <v-btn text @click="submitted = false" class="mt-4">close</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row wrap>
      <v-col cols="12" class="headline pl-0">
        <v-btn
          color="primary"
          class="mr-2 pa-0"
          small
          outlined
          text
          to="/app-support"
          style="margin-top:-3px"
          ><v-icon>chevron_left</v-icon></v-btn
        >
        New App Support Requests
      </v-col>
    </v-row>

    <!-- JOB DETAILS -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <v-select
                      :items="requestCategories"
                      v-model="requestCategory"
                      hide-details
                      label="Category"
                      outlined
                      required
                      :rules="[(v) => !!v || 'Category Required']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" class="mb-0 pb-0">
                    <v-text-field
                      outlined
                      label="Subject"
                      v-model="subject"
                      required
                      :rules="[(v) => !!v || 'Subject Required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" class="pt-0">
                    <v-textarea
                      outlined
                      label="Describe in detail here."
                      v-model="description"
                      required
                      :rules="[(v) => !!v || 'Description Required']"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="6">
          <p>
            * Please make sure you describe your issue or suggestion in full
            detail before submitting.
          </p>
          <v-btn
            class="mr-2"
            :disabled="!valid || submitting"
            block
            color="primary"
            @click="createAppSupportRequest"
            >Submit App Support Request
          </v-btn>
          <span class="red--text font-weight-bold" v-if="!valid"
            >* Missing some required fields above.</span
          >
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      submitting: false,
      submitted: false,
      modal: false,
      snack: false,
      snackColor: "",
      snackText: "",
      requestCategories: [
        "Daily Reports",
        "Payroll",
        "Tool Orders",
        "User Management",
        "Trucking",
        "General / Other",
      ],
      requestCategory: null,
      subject: "",
      description: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  async created() {},
  methods: {
    async createAppSupportRequest() {
      try {
        if (this.$refs.form.validate()) {
          this.submitted = true;
          this.submitting = true;
          try {
            await fb.db.runTransaction(async (transaction) => {
              // Get the metadata document and increment the count.
              const metaRef = fb.db.doc("metadata/appSupportRequests");
              const metaData = (await transaction.get(metaRef)).data() || {};

              const number = metaData.count + 1;

              transaction.update(metaRef, {
                count: number,
              });

              // Update the order document
              const requestRef = fb.db
                .collection("appSupportRequests")
                .doc(number.toString());

              transaction.set(requestRef, {
                orderedBy: this.user,
                orderDate: fb.timestamp,
                orderNumber: number.toString(),
                subject: this.subject,
                description: this.description,
                requestCategory: this.requestCategory,
                notes: [],
                status: "open",
                priority: "none",
              });
            });
            this.$refs.form.reset();
            this.submitting = false;
            this.submitted = true;
          } catch (error) {
            console.log(error);
            this.submitting = false;
            this.submitted = false;
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Error Submitting App Support Request!";
          }
        }
      } catch (error) {
        this.submitting = false;
        this.submitted = false;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error Submitting App Support Request!";
      }
    },
  },
};
</script>
